{
  "title": "Balances",
  "table": {
    "searchPlaceholder": "Search balances",
    "headers": {
      "friendlyName": "Friendly name",
      "entity": "Entity",
      "pendingTransactions": "Pending Transactions",
      "clearedBalance": "Cleared Balance",
      "availableBalance": "Available Balance",
      "action": "Action"
    },
    "action": {
      "dropdown": {
        "header": "Action",
        "view": "View account",
        "downloadLetter": "Download account letter",
        "viewTransactions": "View transactions"
      }
    },
    "dataError": "Access to view balances for the selected entities is restricted for the current user",
    "noIdError": "No user ID found"
  },
  "currencyAccount": {
    "goBack": "Go back to",
    "availableBalance": "Available Balance",
    "friendlyName": {
      "tooltip": {
        "edit": "Edit friendly name",
        "add": "Add friendly name",
        "clear": "Remove Friendly Name"
      },
      "validation": {
        "required": "Account name is required.",
        "tooLong": "Account name must be {{maxLength}} characters or fewer.",
        "tooShort": "Account name must be {{minLength}} characters or more.",
        "invalidCharacters": "Account name can only include letters, numbers, spaces and these symbols: {{allowedSymbols}}",
        "placeholder": "Enter an account name"
      },
      "toast": {
        "success": {
          "title": "Account Name Updated",
          "body": "Your currency account name has been updated successfully."
        },
        "error": {
          "title": "Unable To Update Account Friendly Name",
          "tryAgainError": "Please try again. If the issue continues, please contact Client Services.",
          "permissionDenied": "You no longer have permission to edit this account name."
        }
      }
    },
    "details": "Details",
    "pendingTransfers": "Pending Transfers",
    "noPendingTransfers": "There are no pending transfers.",
    "activity": "Activity",
    "viewMoreTransactions": "View more transactions"
  },
  "outstandingActions": {
    "pendingInvoice": "Pending Invoice",
    "overdue": "KYC Review Overdue",
    "due": "KYC Review Upcoming",
    "actions": "Outstanding actions ({{count}})",
    "pendingTransfers": "Pending Transfer(s)",
    "pendingInvoiceTooltip": "An invoice is due for payment within the next two weeks. Please ensure that sufficient funds are available on your account.",
    "overdueTooltip": "This account is overdue its KYC Review. Please contact the Client Services team urgently to avoid payment restrictions.",
    "pendingTransfer": "Pending Transfer",
    "pendingTransferTooltip": "There are pending transfers on your account awaiting review and approval.",
    "dueTooltipTitle": "Upcoming KYC Review",
    "dueTooltip": "This account has an upcoming KYC review. Please contact the Client Services team to discuss.",
    "actionsTitle": "Outstanding Actions"
  },
  "all": "All",
  "global": "Global",
  "numberOfAccounts": "{{numberOfAccounts}} accounts",
  "downloadAccountLetter": "Download account letter",
  "downloadingAccount": "Downloading account letter",
  "friendlyName": {
    "edit": "Edit friendly name",
    "add": "Add friendly name",
    "modal": {
      "title": "Edit Account Friendly Name",
      "input": "Friendly name",
      "placeholder": "Enter an account name"
    }
  },
  "details": {
    "currency": "Currency",
    "iban": "IBAN",
    "accountNumber": "Account number",
    "sortCode": "Sort code",
    "swiftBic": "SWIFT/BIC",
    "reference": "Pay-in reference",
    "pendingTransactions": "Pending Transactions",
    "type": "Beneficiary Type",
    "clearedBalance": "Cleared balance"
  },
  "kycAlert": {
    "frozen": {
      "title": "{{account}} has been frozen",
      "content": "The entity that owns this currency account has been frozen. We understand this may be inconvenient for you, but we appreciate your cooperation in helping comply with regulatory requirements. Please contact your client services team to verify your information."
    },
    "overdue": {
      "title": "Overdue KYC Review - {{account}}",
      "content": "The entity that owns this currency account is overdue for a periodic KYC review. This entity is at risk of being frozen, please contact client services."
    },
    "due": {
      "title": "Upcoming KYC Review - {{account}}",
      "content": "The entity that owns this currency account is coming up to the deadline for a periodic KYC review. If you do not meet the deadline then this entities may be frozen, please contact client services"
    }
  },
  "frozen": "Frozen",
  "allCurrencies": "All Currencies"
}
